"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseTransition = BaseTransition;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactTransitionGroup = require("react-transition-group");
var _noop = require("../_utils/noop");
var _excluded = ["in", "onExit", "onExited", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function BaseTransition(_ref) {
  var enter = _ref.in,
    _ref$onExit = _ref.onExit,
    _onExit = _ref$onExit === void 0 ? _noop.noop : _ref$onExit,
    _ref$onExited = _ref.onExited,
    _onExited = _ref$onExited === void 0 ? _noop.noop : _ref$onExited,
    children = _ref.children,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  // 离场时保持 children 不变
  var childrenRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, (0, _extends2.default)({}, props, {
    in: enter,
    onExit: function onExit() {
      childrenRef.current = children;
      _onExit.apply(void 0, arguments);
    },
    onExited: function onExited() {
      childrenRef.current = null;
      _onExited.apply(void 0, arguments);
    }
  }), childrenRef.current || children);
}